

  <template>
  <div>
    <iModal
      v-model="showModal"
      class-name="vertical-center-modal"
      width="900px"
      :footer-hide="true"
      :mask-closable="false"
      @on-cancel="$emit('close')"
      :styles="{top: '100px'}"
    >
      <div class="choice">
        <div class="choice-line">
          <span class="choice-line-title">全部</span>
          <Form ref="formInline" inline class="choice-form">
            <FormItem>
              <DatePicker
                type="daterange"
                placeholder="按时间"
                style="width: 100%"
                @on-change="timeChange"
              ></DatePicker>
            </FormItem>
            <FormItem>
              <Select v-model="city" placeholder="按城市" filterable @on-change="change" clearable>
                <Option
                  v-for="item in cityArr"
                  :value="item.value"
                  :key="item.value"
                >{{ item.label }}</Option>
              </Select>
            </FormItem>
            <FormItem>
              <Select v-model="industry" placeholder="按行业" filterable @on-change="change" clearable>
                <Option
                  v-for="item in industryArr"
                  :value="item.name"
                  :key="item.name"
                >{{ item.name }}</Option>
              </Select>
            </FormItem>
          </Form>
        </div>
        <div class="choice-box" v-if="list && list.items && list.items.length">
          <Row :gutter="10">
            <Col span="12" v-for="(item, index) in list.items" :key="index">
              <div class="choice-box-item" @click="$emit('change', item)">
                <div class="cbi-l">
                  <img :src="item.logo" v-if="item.logo" />
                  <img src="@/assets/img/empty.png" v-else />
                </div>
                <div class="cbi-c">
                  <div class="name" :title="item.name">{{item.name}}</div>
                  <div
                    class="info"
                  >时间：{{item.startTime | moment("YYYY/MM/DD")}}~{{item.endTime | moment("YYYY/MM/DD")}}</div>
                  <div class="info" :title="item.address">地点：{{item.address}}</div>
                </div>
                <div class="cbi-r">
                  <span v-if="item.orderIndex === 1" class="status s-1">正在开展</span>
                  <span v-if="item.orderIndex === 2" class="status s-2">即将开展</span>
                  <span v-if="item.orderIndex === 3" class="status s-3">结束</span>
                </div>
              </div>
            </Col>
          </Row>
        </div>
        <div class="u-empty" v-else>暂无数据</div>
      </div>
      <div class="footer" v-if="totalCount > pageSize">
        <div class="my-page">
          <Page
            show-total
            show-elevator
            :page-size="pageSize"
            :current="pageIndex"
            :total="totalCount"
            @on-change="changePage"
            @on-page-size-change="changePageSize"
          />
        </div>
      </div>
    </iModal>
  </div>
</template>

<script>
let moment = require("moment");
import { mapGetters, mapActions } from "vuex";

export default {
  name: "exhibition-choice-modal",
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      value2: ["2016-01-01", "2016-02-15"],
      time: [null, null],
      loading: false,
      showModal: false,
      pageSize: 12,
      pageIndex: 1,
      totalCount: 0,
      cityArr: [
        {
          value: "成都",
          label: "成都"
        },
        {
          value: "上海",
          label: "上海"
        }
      ],
      industryArr: [],
      city: "",
      industry: "",
      exTypeArr: [],
      list: [] // 展会列表
    };
  },
  computed: {
    ...mapGetters({}),
    option() {
      let opt = {
        Wheres: {
          Type: 0,
          Wheres: {
            WhereGroupOperator: 0,
            Predicates: []
          }
        }
      };
      if (this.industry) {
        opt.Wheres.Wheres.Predicates.push({
          type: 1,
          wheres: {
            WhereOperator: 6,
            Label: "Industry",
            Value: `%${this.industry || ""}%`
          }
        });
      }
      if (this.city) {
        opt.Wheres.Wheres.Predicates.push({
          type: 1,
          wheres: {
            WhereOperator: 6,
            Label: "City",
            Value: `%${this.city || ""}%`
          }
        });
      }
      if (this.time && this.time.length && this.time[0]) {
        opt.Wheres.Wheres.Predicates.push({
          type: 2,
          wheres: {
            Label: "StartTime",
            Value: {
              Value1: this.time[0] || "",
              Value2: this.time[1] || ""
            }
          }
        });
      } 
      return opt;
    }
  },
  watch: {
    show(val, oldVal) {
      this.showModal = val;
      if (!val) this.$emit("close");
    }
  },
  async created() {
    let data = await this.getIndustryListAndChildren();
    if (data && data.length) {
      this.industryArr = data;
    }
    this.init();
  },
  methods: {
    ...mapActions({
      getIndustryListAndChildren: "exhibitionModule/getIndustryListAndChildren",
      getExhibitionAll: "exhibitionModule/getExhibitionAll"
    }),
    // 活动发布
    async handleSubmit(name) {
      let form = this.formInline;
      let valid = await this.validForm(name);
      if (!valid) return;
      let formData = {};
    },
    // 验证表单
    validForm(name) {
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
    async init() {
      let list = await this.getExhibitionAll(this.option);
      if (list) {
        this.list = list;
        this.pageSize = this.list.pageSize;
        this.pageIndex = this.list.pageIndex;
        this.totalCount = this.list.totalCount;
      }
    },
    changePage(e) {
      this.pageIndex = e;
      this.init();
      
    },
    changePageSize(e) {
      this.pageSize = e;
      this.init();
      
    },
    change(e) {
      this.pageIndex = 1;
      this.init();
    },
    timeChange(e) {
      this.time = e;
      this.init();
    }
  }
};
</script>

<style lang="scss">
.choice {
  height: 729px;
  padding-top: 20px;
  &-line {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    &-title {
      width: 94px;
      text-align: center;
      font-size: 16px;
      color: #333;
    }
    .ivu-form-item {
      margin-bottom: 0;
    }
  }
  &-form {
    padding-right: 50px;
    display: flex;
    .ivu-form-item {
      flex: 1;
    }
    flex: 1;
  }
  &-box {
    height: 500px;
    padding: 10px;
    overflow: auto;
    &-item {
      height: 110px;
      border-radius: 5px;
      border: solid 1px rgba(221, 221, 221, 0.3);
      padding: 20px 18px;
      display: flex;
      margin-bottom: 10px;
      cursor: pointer;
      transition: all 0.3s;
      &:hover {
        border-color: rgba(221, 221, 221, 0.6);
      }
    }
  }
  .cbi {
    display: flex;
    &-l {
      margin-right: 16px;
      display: flex;
      align-items: center;
      img {
        width: 60px;
        height: 60px;
        background-color: #fff;
        border: solid 1px #e6e6e6;
        border-radius: 50%;
      }
    }
    &-c {
      margin-right: 16px;
      flex: 1;
      .name {
        font-size: 16px;
        color: #262626;
        margin-bottom: 14px;
        width: calc(100% - 1px);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .info {
        width: calc(100% - 1px);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 14px;
        color: #8c8c8c;
      }
    }
    &-r {
      display: flex;
      align-items: center;
      width: 70px;
      .status {
        display: inline-block;
        color: #fff;
        padding: 2px 6px;
        &.s-1 {
          background-color: #1890ff;
        }
        &.s-2 {
          background-color: #fe791e;
        }
        &.s-3 {
          background-color: #999;
        }
      }
    }
  }
}
.footer {
  text-align: center;
  padding-top: 20px;
}
</style>